import React from 'react';
import { SpotlightTransition } from '@atlaskit/onboarding';
import { Text } from '@atlaskit/primitives';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import {
	FireScreenAnalytics,
	ContextualAnalyticsData,
	MODAL,
} from '@atlassian/jira-product-analytics-bridge';
import { AnalyticsSpotlightCard } from '@atlassian/jira-servicedesk-itsm-onboarding-common/src/ui/analytics-spotlight-card/index.tsx';
import { StyledSpotlight } from '@atlassian/jira-servicedesk-itsm-onboarding-common/src/ui/styled-spotlight/index.tsx';
import { JiraSpotlight } from '@atlassian/jira-spotlight/src/ui/jira-spotlight.tsx';
import { SPOLIGHT_SCREEN_NAME, SPOTLIGHT_ID, SPOTLIGHT_TARGET_ID } from './constants.tsx';
import messages from './messages.tsx';

export const ChangeboardingSpotlight = ({ onAcknowledge }: { onAcknowledge: () => void }) => {
	const { formatMessage } = useIntl();

	return (
		<SpotlightTransition>
			{expValEquals('rtc_form_empty_state_to_all_user', 'cohort', 'experiment') ? (
				<ContextualAnalyticsData sourceName={SPOLIGHT_SCREEN_NAME} sourceType={MODAL}>
					<JiraSpotlight
						heading={formatMessage(messages.title)}
						target={SPOTLIGHT_TARGET_ID}
						actions={[
							{
								text: formatMessage(messages.gotIt),
								onClick: onAcknowledge,
							},
						]}
						dialogWidth={336}
						key={SPOTLIGHT_ID}
						dialogPlacement="top right"
						messageId="proforma-request-type-config.ui.form-empty-state.changeboarding-spotlight.jira-spotlight"
						messageType={fg('bug-fix-add-form-button-onboarding') ? 'transactional' : 'engagement'}
					>
						<Text as="p">{formatMessage(messages.message)}</Text>
					</JiraSpotlight>
					<FireScreenAnalytics />
				</ContextualAnalyticsData>
			) : (
				<StyledSpotlight
					dialogWidth={336}
					target={SPOTLIGHT_TARGET_ID}
					dialogPlacement="top right"
					messageId="proforma-request-type-config.ui.form-empty-state.changeboarding-spotlight.styled-spotlight"
					messageType={fg('bug-fix-add-form-button-onboarding') ? 'transactional' : 'engagement'}
				>
					<AnalyticsSpotlightCard
						sourceName={SPOLIGHT_SCREEN_NAME}
						spotlightId={SPOTLIGHT_ID}
						buttons={{
							primary: {
								text: formatMessage(messages.gotIt),
								onClick: onAcknowledge,
							},
						}}
					>
						<Text as="p">{formatMessage(messages.text)}</Text>
					</AnalyticsSpotlightCard>
				</StyledSpotlight>
			)}
		</SpotlightTransition>
	);
};
